import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`I'm hyper bored most of my life`}</h4>
    <p>{`I am a tech freak, I really love to see how tech blooms`}<br parentName="p"></br>{`
`}{`I am aspiring to be a full stack developer and hope to be helpful
to the vast dev community in the world someday.`}<br parentName="p"></br>{`
`}{`For now I just try to explore new things and laze around all day :P`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      